

Fancybox.bind('[data-fancybox]', {
        // Custom options for all galleries
  loop : false,
  thumbs : {
    showOnStart : true
  }
      });  



$('.product-gallery__slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

$(".product-help-button .primary-button").click(function() {
    $('html,body').animate({
        scrollTop: $("#question").offset().top - 20
    },'slow');
});

var Specification_Top = $("#specifications").offset().top - 220;

$("#condition-top-a").click(function(e) {
    e.preventDefault();

    var Data_content = '#specifications';

    var tabs = document.querySelectorAll('.pt_tabs a');
    tabs.forEach(function (tab) {
      tab.classList.remove('active_tab');
    });
  
    $('.specifications_tab').addClass('active_tab');

    var tabPanes = document.querySelectorAll('.tabs-contents .w-tab-pane');
    tabPanes.forEach(function (pane) {
      pane.style.display = 'none';
      pane.classList.remove('active_panel');
    });
    
    var activePane = document.querySelector(Data_content);
    if (activePane) {
      activePane.style.display = 'block';
      activePane.classList.add('active_panel');
    }
  
    $('html,body').animate({
        scrollTop: Specification_Top
    },'slow');
});

// Get the div element by its ID
var specificationsDiv = document.getElementById('specifications');

// Check if the div is empty or contains only whitespace
if (!specificationsDiv || specificationsDiv.textContent.trim() === '') {
    // Hide the div by setting its display style to 'none'
    specificationsDiv.textContent = 'No content found';
}

// Get the div element by its ID
var specificationsDiv = document.getElementById('description');
var specificationslink = document.getElementById('description_link');

// Check if the div is empty or contains only whitespace
if (!specificationsDiv || specificationsDiv.textContent.trim() === '') {
    // Hide the div by setting its display style to 'none'
    specificationsDiv.remove();
    specificationslink.remove();
}